// Gemeinsamer Scope/Epoch für Hub-Read-Caches (User + Mandant + Clear-Generation).

import {
  ACTIVE_TENANT_CHANGED_EVENT,
  getActiveTenantId,
} from "../platform/active-tenant.js";
import { getSupabaseUser } from "../supabase/index.js";

let __epoch = 0;
/** @type {Array<() => void>} */
const __clearFns = [];

export function getHubCacheEpoch() {
  return __epoch;
}

/**
 * @param {() => void} fn
 * @returns {() => void} unregister
 */
export function registerHubCacheClear(fn) {
  if (typeof fn !== "function") return () => {};
  __clearFns.push(fn);
  return () => {
    const idx = __clearFns.indexOf(fn);
    if (idx >= 0) __clearFns.splice(idx, 1);
  };
}

export function clearRegisteredHubCaches() {
  __epoch += 1;
  for (const fn of __clearFns) {
    try {
      fn();
    } catch {
      /* best effort */
    }
  }
}

/**
 * @returns {Promise<{ userId: string, tenantId: string, epoch: number, key: string }>}
 */
export async function resolveHubReadScope() {
  const user = await getSupabaseUser().catch(() => null);
  const userId = String(user?.id || "").trim();
  const tenantId = String(getActiveTenantId() || "").trim();
  return {
    userId,
    tenantId,
    epoch: __epoch,
    key: `${userId}|${tenantId}`,
  };
}

/**
 * @param {{ userId: string, tenantId: string, epoch: number }} started
 * @param {{ userId?: string }} [liveUser]
 */
export function isHubReadScopeCurrent(started, liveUser = null) {
  if (!started) return false;
  if (started.epoch !== __epoch) return false;
  const tenantId = String(getActiveTenantId() || "").trim();
  if (tenantId !== String(started.tenantId || "").trim()) return false;
  if (liveUser && "userId" in liveUser) {
    return (
      String(liveUser.userId || "").trim() ===
      String(started.userId || "").trim()
    );
  }
  return true;
}

let __tenantListenerBound = false;
function __bindTenantListener() {
  if (__tenantListenerBound || typeof window === "undefined") return;
  __tenantListenerBound = true;
  window.addEventListener(ACTIVE_TENANT_CHANGED_EVENT, () => {
    clearRegisteredHubCaches();
  });
}
__bindTenantListener();
